import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { map } from 'rxjs';
import { UserState } from '@shared/states/user.state';
import { TranslateService } from '@shared/translates/translate.service';
import { Authority } from '@shared/types/authority';
import { LayoutState } from 'app/layout/layout.state';

export const SubscriptionCanMatchGuard: CanMatchFn = (route) => {
  const userState = inject(UserState);
  const layoutState = inject(LayoutState);
  const translateService = inject(TranslateService);
  const bySubscription = route.data?.bySubscription as boolean;
  const authorities = route.data?.authorities as Authority[];
  const pageTitle = route.data?.seo?.pageTitle as string;

  let hasAccessToPage = true;

  if (authorities?.length) {
    if (!userState.hasAuthorities(authorities, 'one_of')) {
      hasAccessToPage = false;
    }
  }

  if (hasAccessToPage) {
    return true;
  }

  const needSubscription =
    bySubscription &&
    userState.needSubscription() &&
    userState.hasDisabledAuthorities(authorities, 'one_of') &&
    !userState.hasEarlyAccess(authorities, 'one_of');

  if (needSubscription) {
    return translateService.get$(pageTitle).pipe(
      map((title) => {
        layoutState.subscriptionNotificationData$.next({ title });
        return !needSubscription;
      }),
    );
  }

  return !needSubscription;
};
